import { useEffect } from "react"
import config from "../config/config.json"
import { axiosAuth_IDENT_MGMT_API } from "../utils/AxoisUtilComponent"
import { getI18n } from "react-i18next"

let timerId
const logoutIfIdle = () => {
  clearTimeout(timerId)

  timerId = setTimeout(async () => {
    axiosAuth_IDENT_MGMT_API.post("logout", {}).then(function (response) {
      sessionStorage.setItem("accessToken", "")

      window.location.href = "/Login/" + getI18n().language
    })
  }, (config.timeoutLength) * 60 * 1000)
}

export const tryPageIdleMode = () => {
  if (!config.enablePageIdle) {
    return
  }

  logoutIfIdle()
  document.documentElement.addEventListener("click", logoutIfIdle)
}

export const usePageIdle = () => {
  useEffect(() => {
    tryPageIdleMode()
  }, [])
}
